
import { CircularProgress } from "@mui/material";

const ContainedMuniSpinner = (props) => {
  const { width = 70, height = 70, size = 100 } = props

  return (
    <div className="d-flex justify-content-center align-items-center w-full" style={{ width: width, height: height }}>
      <CircularProgress size={size} className="position-absolute" />
      <img src={process.env.PUBLIC_URL + '/muni-icon-192.png'} alt="Municipalidad Spinner" style={{ width: width, height: height, position: 'absolute' }} />
    </div >
  );
};

export default ContainedMuniSpinner;
